import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../../../../../services/contentful.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.less'
})
export class LandingComponent implements OnInit {

  locale = 'en-US';
  headerFooterCMSData: any;
  landingCMSData: any;

  constructor(
    private contentfulService: ContentfulService
  ) {}

  ngOnInit(): void {
    this.getHeaderFooterLabelCMSData();
    this.getLandingCMSData();
  }

  getHeaderFooterLabelCMSData() {
    this.contentfulService.getContent("657FKyg3tI6y8E4KEMlp9x", this.locale).subscribe(
      (data:any) => {
        this.headerFooterCMSData = data;
      }
    );
  }

  getLandingCMSData() {
    this.contentfulService.getContent("7yFGT5k3j7041DdDL7BC2D", this.locale).subscribe(
      (data:any) => {
        this.landingCMSData = data;
      }
    );
  }
}
